/* eslint-disable import/no-cycle */
import React, { useState, createContext, useContext, useCallback, useMemo } from 'react'
// import zionDebug from '@fs/zion-debug'
import { NotFound, Route } from '@fs/zion-router'
import { i18n } from '@fs/zion-locale'
import usePlaceReportsIndex from './hooks/usePlaceReportsIndex'

// const debug = zionDebug('standards:cvManager:PlaceReportsPageProvider')
const PlaceReportsAppContext = createContext({})

export default function PlaceReportsPageProvider({ children, placeManagerState }) {
  return (
    <PlaceReportsAppContext.Provider value={placeManagerState}>
      {placeManagerState?.permissionsError ? <Route component={NotFound} /> : children}
    </PlaceReportsAppContext.Provider>
  )
}

export function usePlaceReportsData() {
  const [locale, setLocale] = useState(i18n.language || 'en')
  const [selectedLocale, setSelectedLocale] = useState(i18n.language || 'en')
  const { reportsIndex, setReportsIndex, error: reportsIndexError } = usePlaceReportsIndex()

  const getRegion = useCallback(
    (id) => {
      const report = (reportsIndex?.regions || []).find((region) => Number(region.id) === Number(id))
      return report
    },
    [reportsIndex]
  )

  const getCountryAndRegion = useCallback(
    (id) => {
      let country = null
      const region = (reportsIndex?.regions || []).find((r) => {
        country = (r?.countries || []).find((c) => Number(c.id) === Number(id))
        return country
      })
      return { region, country }
    },
    [reportsIndex]
  )

  const getDivision = useCallback(
    (id) => {
      let division = null
      let country = null
      const region = (reportsIndex?.regions || []).find((r) => {
        country = (r?.countries || []).find((c) => {
          division = (c?.divisions || []).find((d) => Number(d.id) === Number(id))
          return division
        })
        return country
      })
      return { region, country, division }
    },
    [reportsIndex]
  )

  const countries = useMemo(() => {
    const allCountries = []
    reportsIndex?.regions?.forEach((r) => {
      allCountries.push(...(r?.countries || []))
    })
    return allCountries
  }, [reportsIndex])

  return {
    locale,
    selectedLocale,
    setLocale,
    setSelectedLocale,
    reportsIndex,
    setReportsIndex,
    reportsIndexError,
    getRegion,
    getCountryAndRegion,
    getDivision,
    countries,
  }
}

export function usePlaceReportsPageData() {
  const cvAppData = useContext(PlaceReportsAppContext)
  if (typeof cvAppData === 'undefined') {
    throw new Error('This hook must be used within a PlaceReportsPageProvider')
  }
  return cvAppData
}
